import isString from 'lodash/isString';
import { createSelector } from 'reselect';
import { idTypes } from 'srcAlias/enums/idTypes';

const { pattern } = (MARKET => {
  try {
    return require(`../../../../config/${MARKET}/patterns/nric-number.json`);
  } catch (_) {
    return {};
  }
})(__MARKET__);

export const getCustomerSegmentState = state =>
  state.segmentState?.customer || {};

export const getPersonalDetails = createSelector(
  getCustomerSegmentState,
  customer => customer.personalDetails || {}
);

export const getFullName = createSelector(
  getPersonalDetails,
  ({ firstNames, fullName, lastName }) =>
    fullName
      ? fullName
      : firstNames && lastName
      ? `${firstNames} ${lastName}`
      : ''
);

export const getDocUploadDocumentIdNumber = createSelector(
  getPersonalDetails,
  ({ identificationDetails = {}, myKADNumber, nricNumber, passport }) => {
    const IdType =
      nricNumber && isString(pattern) && new RegExp(pattern).test(nricNumber)
        ? idTypes.NRIC
        : idTypes.FIN;

    const nonNricNumber = myKADNumber ? myKADNumber : passport;

    const documentIdNumber =
      IdType === idTypes.NRIC ? nricNumber : nonNricNumber;

    return documentIdNumber || identificationDetails.documentIdNumber || '';
  }
);
